import { useState } from "react";
import { Crown, Loader2, Check, LogIn } from "lucide-react";
import { toast } from "sonner";
import { startCheckout } from "@/lib/api";
import { useAuth, login } from "@/lib/auth";

export const UpgradeButton = ({ className = "", label = "Unlock Pro - $9.99" }) => {
  const [busy, setBusy] = useState(false);
  const { user } = useAuth();
  const go = async () => {
    if (!user) return login();
    setBusy(true);
    try {
      const { checkout_url } = await startCheckout();
      window.location.href = checkout_url;
    } catch {
      toast.error("Couldn't start checkout. Please try again.");
      setBusy(false);
    }
  };
  return (
    <button onClick={go} disabled={busy} data-testid="upgrade-pro-btn"
      className={`inline-flex items-center justify-center gap-2 bg-amber-500 hover:bg-amber-400 disabled:opacity-60 text-[#0B0D10] font-display font-bold uppercase rounded-sm transition-colors duration-200 h-12 px-6 ${className}`}>
      {busy ? <Loader2 size={16} className="animate-spin" /> : user ? <Crown size={16} /> : <LogIn size={16} />} {user ? label : "Sign in to go Pro"}
    </button>
  );
};

export const Paywall = () => (
  <div className="relative overflow-hidden border border-amber-500/50 bg-[#13171F] rounded-sm p-6" data-testid="paywall">
    <div className="hazard absolute top-0 left-0 right-0 h-1" />
    <p className="font-mono text-xs uppercase tracking-widest text-amber-500">Free limit reached</p>
    <h3 className="font-display text-3xl font-extrabold uppercase mt-2">Go GearHead Pro</h3>
    <ul className="mt-4 space-y-2 text-sm text-slate-300">
      {["Unlimited AI Mechanic messages (Claude & ChatGPT)", "Photo diagnosis: snap a leak or warning light", "Saved to your Google account on every device", "One-time payment of $9.99 - yours forever"].map((t) => (
        <li key={t} className="flex gap-2"><Check size={16} className="text-emerald-400 shrink-0" /> {t}</li>
      ))}
    </ul>
    <UpgradeButton className="mt-6 w-full" />
  </div>
);
